import React from "react";
import {connect} from "react-redux";
import {Button, Col, Divider, Form, Input, InputNumber, Modal, Row, Select, Space, message} from "antd";
import {editFirewallPolicy, loadFirewallPolicy, loadFirewallRules, loadFirewallRulesets} from "../../actions/firewall";
import {displayErrors, isNumeric} from "../../libs/utils";
import {Loading} from "../../libs/loading";

class EditFirewallPolicyModal extends React.Component {
    state = {
        name: '',
        priority: 0,
        rulesets: [],
        selectedRulesets: [],
        loadingRulesets: true,
        rules: [],
        selectedRules: [],
        loadingRules: true,
        loadingData: false,
        dataLoaded: false,
        editing: false,
        policyLoaded: false
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!this.state.loadingData && this.props.showModal && !this.state.dataLoaded) {
            this.setState({ loadingData: true });

            this.props.loadFirewallPolicy(this.props.policy, (res) => {
                let rulesets = res.data.rulesets.map((ruleset) => {
                    return ruleset.guid;
                });

                let rules = res.data.rules.map((rule) => {
                    return rule.guid;
                });

                this.setState({ policyLoaded: true, name: res.data.name, priority: res.data.priority, selectedRulesets: rulesets,
                    selectedRules: rules, dataLoaded: true });
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ policyLoaded: true, dataLoaded: true });
                    displayErrors(err.response.data);
                }
            });

            this.props.loadFirewallRules(1, 9999, (res) => {
                let rules = res.data.data.map((rule) => {
                    return { label: rule.name, value: rule.guid };
                });

                this.setState({ rules, loadingRules: false });

            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ loadingRules: false });
                    displayErrors(err.response.data);
                }
            });

            this.props.loadFirewallRulesets(1, 9999, (res) => {
                let rulesets = res.data.data.map((ruleset) => {
                    return { label: ruleset.name, value: ruleset.guid };
                });

                this.setState({ rulesets, loadingRulesets: false });

            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ loadingRulesets: false });
                    displayErrors(err.response.data);
                }
            });
        }
    }

    closeModal(reload = false) {
        this.props.close();

        this.setState({
            name: '',
            priority: 0,
            rulesets: [],
            selectedRulesets: [],
            loadingRulesets: true,
            rules: [],
            selectedRules: [],
            loadingRules: true,
            loadingData: false,
            dataLoaded: false,
            editing: false,
            policyLoaded: false
        });

        if(reload) {
            this.props.reloadPolicies();
        }
    }

    editPolicy() {
        let name = this.state.name.trim();
        let priority = this.state.priority;
        let rulesets = this.state.selectedRulesets;
        let rules = this.state.selectedRules;

        if(name.length === 0) {
            return message.error('Enter your policy\'s name!');
        }

        if(!isNumeric(priority)) {
            return message.error('Priority must be a number between 0 and 9999!');
        }

        if(rulesets.length === 0 && rules.length === 0) {
            return message.error('Select at least one ruleset or rule!');
        }

        let data = {
            name, priority, rulesets, rules
        };

        this.setState({ editing: true });

        this.props.editFirewallPolicy(this.props.policy, data, () => {
            message.success('Firewall policy successfully updated!');
            this.setState({ editing: true });
            this.closeModal(true);
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ editing: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        let content;

        if(!this.state.policyLoaded) {
            content = <div className='text-center'><Loading /></div>;
        }
        else
        {
            content = <Form layout='vertical'>
                <Row gutter={[16, 16]}>
                    <Col span={19}>
                        <Form.Item label='Name'>
                            <Input value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} />
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item label='Priority'>
                            <InputNumber value={this.state.priority} onChange={(value) => this.setState({ priority: value })} min={0} max={9999} />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider plain>Rules</Divider>
                <Form.Item label='Rule sets'>
                    <Select
                        options={this.state.rulesets}
                        loading={this.state.loadingRulesets}
                        value={this.state.selectedRulesets}
                        mode='multiple' showSearch allowClear
                        onChange={(values) => this.setState({ selectedRulesets: values })}
                        filterOption={(input, option) => {
                            if(typeof option !== 'undefined') {
                                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }
                            return false;
                        }} />
                </Form.Item>
                <Form.Item label='Rules'>
                    <Select
                        options={this.state.rules}
                        loading={this.state.loadingRules}
                        value={this.state.selectedRules}
                        mode='multiple' showSearch allowClear
                        onChange={(values) => this.setState({ selectedRules: values })}
                        filterOption={(input, option) => {
                            if(typeof option !== 'undefined') {
                                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }
                            return false;
                        }} />
                </Form.Item>
            </Form>;
        }

        return(
            <Modal
                title='Edit Firewall Policy'
                open={this.props.showModal}
                destroyOnClose={true}
                footer={
                    <Space>
                        <Button onClick={() => this.closeModal()} disabled={this.state.editing}>Close</Button>
                        <Button type='primary' onClick={() => this.editPolicy()} loading={this.state.editing} disabled={this.state.editing}>Update</Button>
                    </Space>
                }
                onCancel={() => this.closeModal()}>
                {content}
            </Modal>
        );
    }
}

export default connect(null, { loadFirewallRules, loadFirewallRulesets, editFirewallPolicy, loadFirewallPolicy })(EditFirewallPolicyModal);